/**
 * Kimlik doğrulama modu.
 * Varsayılan: `api` (canlı Login). Demo oturum: `.env` → `REACT_APP_AUTH_MODE=simulation`
 * @type {'simulation' | 'api'}
 */
export const AUTH_MODE =
    process.env.REACT_APP_AUTH_MODE === 'simulation'
        ? 'simulation'
        : 'api';

/**
 * Yerel simülasyon ayarları (tarayıcıda oturum, sunucu yok).
 */
export const AUTH_SIMULATION = {
    /** localStorage anahtarı — gerçek API’de token anahtarıyla değiştirilebilir */
    storageKey: 'rotary-auth-user',
    /**
     * Girişte kısa gecikme (ms); ağ çağrısı hissi. 0 = bekleme yok.
     */
    loginDelayMs: 450,
};

/**
 * @param {string} email
 */
export function buildSimulatedUser(email) {
    const trimmed = email.trim();
    const local = trimmed.split('@')[0] || 'üye';
    const name = local.charAt(0).toUpperCase() + local.slice(1);
    return {
        email: trimmed,
        name,
        /** Oturum bu yapı ile oluşturulduysa true (isteğe bağlı tanı) */
        simulatedSession: true,
    };
}

/**
 * Simülasyonda yalnızca alanların dolu olmasını kontrol eder.
 * @param {string | undefined} email
 * @param {string | undefined} password
 */
export function assertSimulatedCredentials(email, password) {
    if (!email?.trim()) {
        throw new Error('E-posta gerekli');
    }
    if (!password) {
        throw new Error('Şifre gerekli');
    }
}

/**
 * Simüle edilmiş ağ gecikmesi.
 * @returns {Promise<void>}
 */
export function waitSimulatedLogin() {
    const ms = AUTH_SIMULATION.loginDelayMs;
    if (ms <= 0) {
        return Promise.resolve();
    }
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
}
